<template>
  <div class="inline-block" v-html="svg"></div>
</template>

<style module>
.svg {
  height: 1em;
  vertical-align: middle;
  width: 1em;
}

.stroke {
  stroke: currentColor;
}

.fill {
  fill: currentColor;
}
</style>

<script>
export default {
  props: {
    icon:  {
      required: true,
      type: String
    },
    stroke:  {
      required: false,
      type: Boolean,
      default: false
    },
    fill:  {
      required: false,
      type: Boolean,
      default: false
    },
  },
  computed: {
    svg() {
      // A missing icon file must not break the parent view
      try {
        return require('!html-loader!../assets/icons/icon-' + this.icon + '.svg')
      } catch (e) {
        return ''
      }
    }
  },
  mounted() {
    if(!this.$el.firstChild || !this.$el.firstChild.classList) {
      return;
    }
    this.$el.firstChild.classList.add(this.$style.svg)
    if(this.stroke === true) {
      this.$el.firstChild.classList.add(this.$style.stroke)
    }
    if(this.fill === true) {
      this.$el.firstChild.classList.add(this.$style.fill)
    }
    this.$el.firstChild.removeAttribute('height')
    this.$el.firstChild.removeAttribute('width')
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/SvgIcon.vue